import snakeCase from "lodash/snakeCase";

import { t } from "@/i18n-js/instance";
import type { FlaggedContentableType } from "@/react/types/FlaggedContent";

export interface ModerationInfoBaseProps {
  contentType: FlaggedContentableType;
  record: {
    unresolved_flagged_reports_count: number;
    id: string | number;
  };
}

export const getContentTranslation = (type: FlaggedContentableType) =>
  t(`flagged_contents.moderation_info.${snakeCase(type)}`);

export const shouldRenderContent = (
  record: ModerationInfoBaseProps["record"],
) => Boolean(record.unresolved_flagged_reports_count);
